import React from 'react';
import { TextField, MenuItem } from '@material-ui/core';
import { RESCHEDULE_REASONS, RESCHEDULE_REASON_OTHER } from '@onward-delivery/core';

// Shared reschedule reason picker; notes always available, required only for "Other".
export default function RescheduleReasonFields({ reason, notes, onChangeReason, onChangeNotes, disabled = false }) {
    return (
        <>
            <TextField
                select
                label="Reschedule reason (required)"
                variant="outlined"
                fullWidth
                value={reason || ''}
                onChange={(e) => onChangeReason(e.target.value)}
                disabled={disabled}
                style={{ marginBottom: '16px' }}
            >
                {Object.entries(RESCHEDULE_REASONS).map(([code, label]) => (
                    <MenuItem key={code} value={code}>
                        {label}
                    </MenuItem>
                ))}
            </TextField>
            <TextField
                label={reason === RESCHEDULE_REASON_OTHER ? 'Notes (required)' : 'Notes'}
                variant="outlined"
                fullWidth
                multiline
                minRows={3}
                value={notes || ''}
                onChange={(e) => onChangeNotes(e.target.value)}
                disabled={disabled}
            />
        </>
    );
}
